<div class="card fa-card" *ngIf="vm" style="padding:0;overflow:hidden;margin-top:12px;margin-bottom:10px;">
  <div style="padding:16px 18px 4px;">
    <h3 class="section-title" style="margin-bottom:2px;">{{ 'results.faceAnalysis.title' | translate }}</h3>
  </div>

  <!-- Selfie section label -->
  <div style="padding:20px 20px 10px;display:flex;align-items:center;justify-content:space-between;">
    <div>
      <div style="font-size:10px;font-weight:700;letter-spacing:0.13em;text-transform:uppercase;color:var(--brand-text-safe, var(--accent));margin-bottom:4px;">{{ 'results.faceAnalysis.kicker' | translate }}</div>
      <div style="font-size:13px;color:var(--g500);line-height:1.5;">{{ 'results.faceAnalysis.intro' | translate }}</div>
    </div>
  </div>

  <!-- Real Perfect Corp mask overlay — the SHARED viewer (same as the preview) -->
  <app-skin-filter-viewer
    [photoUrl]="vm.photoUrl"
    [filterData]="vm.filterData"
    [maskImages]="vm.maskImages"
  ></app-skin-filter-viewer>
</div>
